import { render } from "./AccountRegistrationProgressBar.vue?vue&type=template&id=b506a9ce"
import script from "./AccountRegistrationProgressBar.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__